import * as React from "react";
import { toast } from "react-toastify";

import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import { useShutdownsApi } from "src/modules/shutdowns/api/shutdown.api";
import ShutdownForm from "src/modules/shutdowns/components/ShutdownForm";
import { useDrop } from "src/core/drops/hooks";
import { Text } from "src/library/components/Text";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";
import { Icons } from "src/library/components/Icon/types";

/**
 * Drop Shutdown form for creating/editing a shutdown
 *
 */
const CreateEditDropShutdownPage: React.ReactFCWithChildren<PageProps<unknown, {shutdownId?: string; dropOverrideId?: string;}>> = props => {
  const shutdownId = props.match && props.match.params.shutdownId ? parseInt(props.match.params.shutdownId, 10) : null;
  const dropIdOverrideId = props?.match?.params.dropOverrideId ? parseInt(props.match.params.dropOverrideId) : null;
  const [ shutdownsResponse, getShutdown ] = useShutdownsApi("GET_SHUTDOWN");
  const [ { drop } ] = useDrop();
  const dropId = React.useMemo(() => dropIdOverrideId || drop?.id, [ drop?.id, dropIdOverrideId ]);

  // if it fails to load the page give a toast warning and go back
  React.useEffect(() => {
    if (shutdownsResponse.error) {
      toast.error(shutdownsResponse.error.message);
      history.back();
    }
  }, [ shutdownsResponse.error ]);

  React.useEffect(() => {
    if (shutdownId) {
      getShutdown(shutdownId);
    }
  }, [ getShutdown, shutdownId ]);

  return (
    <Layout
      {...props}
      title="Shutdowns"
    >
      <MainContentWrapper fill>

        <ErrorNotice
          type="info"
          icon={Icons.INFO}
        >
          <Text>
            Holidays allow you to block off delivery dates for periods that you will not be able to receive deliveries for.
          </Text>
        </ErrorNotice>

        {dropId && (shutdownsResponse.data || !shutdownId) && (
          <ShutdownForm
            initialShutdown={shutdownsResponse.data || null}
            dropId={dropId}
            disableExtendLeadTimes
          />
        )}
      </MainContentWrapper>
    </Layout>
  );
};

export default CreateEditDropShutdownPage;
